import { useState, useEffect } from "react";
import {
  getPartyList,
  getAllPartyList,
  getPartyListMain,
  getRegions,
} from "../../../../../api/ph-api";
import PartyList from "../../../../../../components/partylist/PartyListWidget";

export const getStaticProps = async () => {
  let regionList = await getRegions();
  let partyList = await getPartyList();
  let partyListMain = await getPartyListMain();
  let allPartyList = await getAllPartyList();

  return {
    props: { partyList, partyListMain, allPartyList, regionList },
    revalidate: 5,
  };
};

const EmbedPartyListOfficialResults = ({
  partyList,
  partyListMain,
  allPartyList,
  regionList,
}) => {
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(
      `${window.location.origin}/elections/2022/races/party-list/official-results`
    );
  }, []);

  return (
    <PartyList
      view={"official-results"}
      regionList={regionList?.results}
      partyList={partyList}
      partyListMain={partyListMain}
      allPartyList={allPartyList}
      url={url}
      isEmbed="true"
    />
  );
};

export default EmbedPartyListOfficialResults;
